import { SortDirection } from './SortDirection';

export class Sort {
    sortColumn: string;
    sortOrder: string;

    constructor() {
    }

    SetSorting(colName: string) {
        if (this.sortColumn) {
            if (this.sortColumn === colName) { // same sort column
                this.SetOrder();
            } else {
                this.sortColumn = null;
            }
        }

        if (!this.sortColumn) {
            this.sortColumn = colName;
            this.sortOrder = SortDirection.Ascending;
        }
    }

    private SetOrder() {
        if (this.sortOrder) {
            if (this.sortOrder === SortDirection.Ascending) {
                this.sortOrder = SortDirection.Descending;
            } else {
                this.sortOrder = SortDirection.Ascending;
            }
        } else {
            this.sortOrder = SortDirection.Ascending;
        }
    }

    resetSorting(columnName: string) {
        this.sortColumn = columnName;
        this.sortOrder = SortDirection.Ascending;
    }

    getSortQueryString(sortField: string): string {
        if (sortField) {
            return `&SortField=${sortField}&SortDirection=${this.sortOrder}`;
        } else {
            return '';
        }
    }
}
